export const SEARCH_ON_LOAD = 'search/on_load';
export const searchOnLoad = () => ({
  type: SEARCH_ON_LOAD
});

export const SEARCH_ON_LOAD_SUCCESS = 'search/on_load_success';
export const searchOnLoadSuccess = data => ({
  type: SEARCH_ON_LOAD_SUCCESS,
  payload: data
});

export const SEARCH_FILTER = 'search/filter';
export const searchFilter = data => ({
  type: SEARCH_FILTER,
  payload: data
});

export const SEARCH_FILTER_SUCCESS = 'search/filter_success';
export const searchFilterSuccess = data => ({
  type: SEARCH_FILTER_SUCCESS,
  payload: data
});

export const SEARCH_RESET = 'search/reset';
export const searchReset = () => ({
  type: SEARCH_RESET
});

export const SEARCH_DETAILS = 'search/details';
export const searchDetails = data => ({
  type: SEARCH_DETAILS,
  payload: data
});

export const SEARCH_DETAILS_SUCCESS = 'search/details_success';
export const searchDetailsSuccess = data => ({
  type: SEARCH_DETAILS_SUCCESS,
  payload: data
});

export const SEARCH_DETAILS_RESET = 'search/details_reset';
export const searchDetailsReset = () => ({
  type: SEARCH_DETAILS_RESET
});

export const RETRIEVE_MTCN = 'retrieve/mtcn';
export const retrieveMtcn = data => ({
  type: RETRIEVE_MTCN,
  payload: data
});

export const RETRIEVE_MTCN_SUCCESS = 'retrieve/mtcn_success';
export const retrieveMtcnSuccess = data => ({
  type: RETRIEVE_MTCN_SUCCESS,
  payload: data
});

export const RETRIEVE_MTCN_RESET = 'retrieve/mtcn_reset';
export const retrieveMtcnReset = () => ({
  type: RETRIEVE_MTCN_RESET
});

export const SEARCH_EXPORT_CSV = 'search/export';
export const searchExportCsv = data => ({
  type: SEARCH_EXPORT_CSV,
  payload: data
});

export const SEARCH_ERROR = 'search/error';
export const searchError = (error) => ({
  type: SEARCH_ERROR,
  payload: error
});

export const TRANSACTION_QUERY = 'transactions/query';
export const transactionQuery = data => ({
  type: TRANSACTION_QUERY,
  payload: data
});
export const TRANSACTION_QUERY_SUCCESS = 'transactions/query_success';
export const transactionQuerySuccess = data => ({
  type: TRANSACTION_QUERY_SUCCESS,
  payload: data
});
export const TRANSACTION_QUERY_FAILURE = 'transactions/query_failure';
export const transactionQueryFailure = data => ({
  type: TRANSACTION_QUERY_FAILURE,
  payload: data
});

